module.exports = __webpack_public_path__ + "img/Icon-Expenses.a1b839d6.svg";